import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "@/components/ScrollToTop";
import Layout from "@/components/Layout";
import { ProtectedRoute, AdminRoute } from "@/components/Guards";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Pricing from "@/pages/Pricing";
import About from "@/pages/About";
import SeoPage from "@/pages/SeoPage";
import Advertising from "@/pages/Advertising";
import LandingPages from "@/pages/LandingPages";
import TestimonialsPage from "@/pages/TestimonialsPage";
import FaqPage from "@/pages/FaqPage";
import ContactPage from "@/pages/ContactPage";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

import Login from "@/pages/auth/Login";
import Register from "@/pages/auth/Register";
import ForgotPassword from "@/pages/auth/ForgotPassword";
import ResetPassword from "@/pages/auth/ResetPassword";
import VerifyEmail from "@/pages/auth/VerifyEmail";

import Checkout from "@/pages/Checkout";
import Payment from "@/pages/Payment";

import DashboardLayout from "@/pages/dashboard/DashboardLayout";
import DashOverview from "@/pages/dashboard/DashOverview";
import DashOrders from "@/pages/dashboard/DashOrders";
import DashProfile from "@/pages/dashboard/DashProfile";
import DashNotifications from "@/pages/dashboard/DashNotifications";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminServices from "@/pages/admin/AdminServices";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminPayments from "@/pages/admin/AdminPayments";
import AdminTestimonials from "@/pages/admin/AdminTestimonials";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminFaq from "@/pages/admin/AdminFaq";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminContact from "@/pages/admin/AdminContact";
import AdminCustomers from "@/pages/admin/AdminCustomers";
import AdminCoupons from "@/pages/admin/AdminCoupons";
import AdminAudit from "@/pages/admin/AdminAudit";

const pub = (el) => <Layout>{el}</Layout>;

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={pub(<Home />)} />
        <Route path="/services" element={pub(<Services />)} />
        <Route path="/services/:slug" element={pub(<ServiceDetail />)} />
        <Route path="/pricing" element={pub(<Pricing />)} />
        <Route path="/about" element={pub(<About />)} />
        <Route path="/seo" element={pub(<SeoPage />)} />
        <Route path="/advertising" element={pub(<Advertising />)} />
        <Route path="/landing-pages" element={pub(<LandingPages />)} />
        <Route path="/testimonials" element={pub(<TestimonialsPage />)} />
        <Route path="/faq" element={pub(<FaqPage />)} />
        <Route path="/contact" element={pub(<ContactPage />)} />
        <Route path="/blog" element={pub(<Blog />)} />
        <Route path="/blog/:slug" element={pub(<BlogDetail />)} />
        <Route path="/terms" element={pub(<Legal kind="terms" />)} />
        <Route path="/privacy" element={pub(<Legal kind="privacy" />)} />
        <Route path="/refund-policy" element={pub(<Legal kind="refund" />)} />

        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/verify-email" element={<VerifyEmail />} />

        <Route path="/checkout" element={<ProtectedRoute>{pub(<Checkout />)}</ProtectedRoute>} />
        <Route path="/payment/:orderId" element={<ProtectedRoute>{pub(<Payment />)}</ProtectedRoute>} />

        <Route path="/dashboard" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
          <Route index element={<DashOverview />} />
          <Route path="orders" element={<DashOrders />} />
          <Route path="profile" element={<DashProfile />} />
          <Route path="notifications" element={<DashNotifications />} />
        </Route>

        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminRoute><AdminLayout /></AdminRoute>}>
          <Route index element={<AdminDashboard />} />
          <Route path="services" element={<AdminServices />} />
          <Route path="orders" element={<AdminOrders />} />
          <Route path="payments" element={<AdminPayments />} />
          <Route path="customers" element={<AdminCustomers />} />
          <Route path="testimonials" element={<AdminTestimonials />} />
          <Route path="blog" element={<AdminBlog />} />
          <Route path="faq" element={<AdminFaq />} />
          <Route path="coupons" element={<AdminCoupons />} />
          <Route path="contact" element={<AdminContact />} />
          <Route path="settings" element={<AdminSettings />} />
          <Route path="audit" element={<AdminAudit />} />
        </Route>

        <Route path="*" element={pub(<NotFound />)} />
      </Routes>
    </BrowserRouter>
  );
}
